import { useEffect, useState } from 'react'
import axios from 'axios'

const useCmsFilterConfig = () => {
  const [cmsGlobalComponents, setCmsGlobalComponents] = useState<any>(undefined)

  useEffect(() => {
    const getCmsData = async () => {
      try {
        const response = await axios.post(
          '/api/getCmsContent',
          {
            contentType: 'globalComponents',
            documentId: '4c6e8f53-b674-4b90-94c5-4cd66bb6aa9e',
            versionId: '',
          },
          {
            headers: {
              Accept: 'application/vnd.vtex.ds.v10+json',
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
          }
        )

        setCmsGlobalComponents(response?.data?.sections)
      } catch (error) {
        console.error('Error', error)
      }
    }

    getCmsData()
  }, [])

  return cmsGlobalComponents
}

export default useCmsFilterConfig
